// Safari does not expose every Opus tuning knob as an API. SDP fmtp is the
// interoperable way to request FEC/DTX/stereo and receiver packet-loss hints.
export function preferOpusOnly(sdp: string): string {
  const lines = sdp.split("\r\n");
  const opusLine = lines.find((line) => /^a=rtpmap:\d+ opus\/48000\/2$/i.test(line));
  if (!opusLine) throw new Error("Opus codec is unavailable");
  const opusPayload = opusLine.match(/^a=rtpmap:(\d+)/)?.[1];
  if (!opusPayload) throw new Error("Invalid Opus SDP");

  const audioIndex = lines.findIndex((line) => line.startsWith("m=audio "));
  if (audioIndex >= 0) {
    const parts = lines[audioIndex].split(" ");
    lines[audioIndex] = [...parts.slice(0, 3), opusPayload].join(" ");
  }

  const fmtpIndex = lines.findIndex((line) => line.startsWith(`a=fmtp:${opusPayload} `));
  const parameters =
    "minptime=10;useinbandfec=1;usedtx=1;stereo=0;sprop-stereo=0;maxaveragebitrate=24000;maxplaybackrate=48000";
  if (fmtpIndex >= 0) {
    const current = lines[fmtpIndex].split(" ", 2)[1] || "";
    const merged = new Map<string, string>();
    `${current};${parameters}`.split(";").forEach((entry) => {
      const [key, value] = entry.split("=");
      if (key && value) merged.set(key.trim(), value.trim());
    });
    lines[fmtpIndex] = `a=fmtp:${opusPayload} ${[...merged].map(([k, v]) => `${k}=${v}`).join(";")}`;
  } else {
    lines.splice(audioIndex + 1, 0, `a=fmtp:${opusPayload} ${parameters}`);
  }

  return lines
    .filter((line) => {
      const match = line.match(/^a=(?:rtpmap|fmtp|rtcp-fb):(\d+)/);
      return !match || match[1] === opusPayload;
    })
    .join("\r\n");
}

